// extracted by css-extract-rspack-plugin
export default {"container":"PinnedIssues-module__container__I30c1","area":"PinnedIssues-module__area__RpXUN"};